import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { DataService } from './dataService.service';
import {HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService  {

  private envUrl = '/api/settings';
    private configSettings: any = null;
  constructor(private dataService:DataService) {
  //  this.dataService.load();
    //this.dataService.prom();
  }

  

}
